// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.members[data-v-291edf64] {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--videomost-members-container);
  user-select: none;
}
.members-container[data-v-291edf64] {
  position: absolute;
  top: 10px;
  left: 50%;
  width: 450px;
  transform: translate(-50%, 0);
  background-color: var(--videomost-members-container);
  color: white;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  overflow: hidden;
  max-height: calc(100% - 20px);
  -webkit-app-region: no-drag;
}
.members-container[data-v-291edf64] .contentt {
  overflow-y: auto;
}
.members-container[data-v-291edf64] .headerr {
  display: flex;
  flex-direction: row;
  padding: 5px;
  font-size: 18px;
  font-weight: 200;
}
.members-container[data-v-291edf64] .headerr .text {
  padding: 5px 10px;
}
.members-container[data-v-291edf64] .headerr .close {
  margin-left: auto;
  cursor: pointer;
  display: flex;
  padding: 5px;
  color: inherit;
  text-shadow: 0 1px 0 var(--bg-color);
}
.members-container[data-v-291edf64] .footerr {
  display: flex;
  padding: 5px;
}
.members-container[data-v-291edf64] .list-item.banned .item-footer {
  color: var(--elem-red-color);
}
.members-container[data-v-291edf64] .list-item:last-child {
  border-bottom: 1px solid var(--border-bottom-selecteditems);
}
.members-container[data-v-291edf64] .list-item:hover {
  background-color: #e8eef72e;
}
.members-container[data-v-291edf64] .list-item .item-content {
  background-color: var(--bg-color-video-cont);
}
.members-container[data-v-291edf64] .list-item .item-text {
  overflow: hidden;
}
.members-container[data-v-291edf64] .list-item .item-text .item-footer {
  color: #ffffffbf !important;
}
.members-container[data-v-291edf64] .list-item .item-after {
  color: inherit;
}
.members-container[data-v-291edf64] .list-item .item-after i {
  margin: 0 20px;
  font-size: 20px;
}
.members-container .buttons[data-v-291edf64] {
  display: flex;
}
.members-container .buttons .btns-left[data-v-291edf64] {
  width: 50%;
  text-align: left;
}
.members-container .buttons .btns-left .btn[data-v-291edf64] {
  color: gainsboro;
}
.members-container .buttons .btns-left .btn[data-v-291edf64]:hover {
  background-color: #7a818c2e;
}
.members-container .buttons .btns-left .btn[data-v-291edf64]:active,
.members-container .buttons .btns-left .btn[data-v-291edf64]:focus {
  background-color: #7a818c4f;
}
.members-container .buttons .btns-right[data-v-291edf64] {
  width: 50%;
  text-align: right;
}
.members-container .icons-block[data-v-291edf64] {
  display: flex;
  align-items: center;
}
.members-container .icons-block .icons i[data-v-291edf64] {
  font-size: 22px;
  margin: 0 12px;
  color: inherit;
}
.members-container .icons-block .icons svg.strikeline[data-v-291edf64] {
  position: absolute;
  margin-left: 8px;
  margin-top: -2px;
}
.members-container .icons-block .icons i.disabled[data-v-291edf64] {
  opacity: 0.5;
}
.members-container .icons-block .icons i.requested[data-v-291edf64] {
  fill: var(--elem-red-color);
}
.members-container .icons-block .icons svg[data-v-291edf64] {
  fill: white;
  margin: 0 12px;
}
.members-container .icons-block .icons svg.requested[data-v-291edf64] {
  fill: var(--elem-red-color);
}
.members-container .icons-block .icons svg.disabled[data-v-291edf64] {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfMembers.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,oDAAoD;EACpD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd","sourcesContent":[".members[data-v-291edf64] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: var(--videomost-members-container);\n  user-select: none;\n}\n.members-container[data-v-291edf64] {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  width: 450px;\n  transform: translate(-50%, 0);\n  background-color: var(--videomost-members-container);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  border-radius: 5px;\n  overflow: hidden;\n  max-height: calc(100% - 20px);\n  -webkit-app-region: no-drag;\n}\n.members-container[data-v-291edf64] .contentt {\n  overflow-y: auto;\n}\n.members-container[data-v-291edf64] .headerr {\n  display: flex;\n  flex-direction: row;\n  padding: 5px;\n  font-size: 18px;\n  font-weight: 200;\n}\n.members-container[data-v-291edf64] .headerr .text {\n  padding: 5px 10px;\n}\n.members-container[data-v-291edf64] .headerr .close {\n  margin-left: auto;\n  cursor: pointer;\n  display: flex;\n  padding: 5px;\n  color: inherit;\n  text-shadow: 0 1px 0 var(--bg-color);\n}\n.members-container[data-v-291edf64] .footerr {\n  display: flex;\n  padding: 5px;\n}\n.members-container[data-v-291edf64] .list-item.banned .item-footer {\n  color: var(--elem-red-color);\n}\n.members-container[data-v-291edf64] .list-item:last-child {\n  border-bottom: 1px solid var(--border-bottom-selecteditems);\n}\n.members-container[data-v-291edf64] .list-item:hover {\n  background-color: #e8eef72e;\n}\n.members-container[data-v-291edf64] .list-item .item-content {\n  background-color: var(--bg-color-video-cont);\n}\n.members-container[data-v-291edf64] .list-item .item-text {\n  overflow: hidden;\n}\n.members-container[data-v-291edf64] .list-item .item-text .item-footer {\n  color: #ffffffbf !important;\n}\n.members-container[data-v-291edf64] .list-item .item-after {\n  color: inherit;\n}\n.members-container[data-v-291edf64] .list-item .item-after i {\n  margin: 0 20px;\n  font-size: 20px;\n}\n.members-container .buttons[data-v-291edf64] {\n  display: flex;\n}\n.members-container .buttons .btns-left[data-v-291edf64] {\n  width: 50%;\n  text-align: left;\n}\n.members-container .buttons .btns-left .btn[data-v-291edf64] {\n  color: gainsboro;\n}\n.members-container .buttons .btns-left .btn[data-v-291edf64]:hover {\n  background-color: #7a818c2e;\n}\n.members-container .buttons .btns-left .btn[data-v-291edf64]:active,\n.members-container .buttons .btns-left .btn[data-v-291edf64]:focus {\n  background-color: #7a818c4f;\n}\n.members-container .buttons .btns-right[data-v-291edf64] {\n  width: 50%;\n  text-align: right;\n}\n.members-container .icons-block[data-v-291edf64] {\n  display: flex;\n  align-items: center;\n}\n.members-container .icons-block .icons i[data-v-291edf64] {\n  font-size: 22px;\n  margin: 0 12px;\n  color: inherit;\n}\n.members-container .icons-block .icons svg.strikeline[data-v-291edf64] {\n  position: absolute;\n  margin-left: 8px;\n  margin-top: -2px;\n}\n.members-container .icons-block .icons i.disabled[data-v-291edf64] {\n  opacity: 0.5;\n}\n.members-container .icons-block .icons i.requested[data-v-291edf64] {\n  fill: var(--elem-red-color);\n}\n.members-container .icons-block .icons svg[data-v-291edf64] {\n  fill: white;\n  margin: 0 12px;\n}\n.members-container .icons-block .icons svg.requested[data-v-291edf64] {\n  fill: var(--elem-red-color);\n}\n.members-container .icons-block .icons svg.disabled[data-v-291edf64] {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
